export const AccountType = {
  MANAGED: 6,
  DIY: 8,
  DSP: 1,
};
